import React from 'react'

export default function CyberBoard() {
  return (
    <div>CyberBoard</div>
  )
}
